import React, { useEffect, useState } from 'react';

const Portal = ({ email }) => {
    const [applications, setApplications] = useState([]);
    const [popup, setPopup] = useState({ show: false, message: '', status: '' });

    // Sample applications data
    const sampleApplications = [
        { id: 1, email: 'user1@example.com', status: 'Pending', adminMessage: 'Your application is under review.' },
        { id: 2, email: 'user1@example.com', status: 'Accepted', adminMessage: 'Congratulations, your application is accepted!' },
        { id: 3, email: 'user2@example.com', status: 'Rejected', adminMessage: 'We are sorry, your application is rejected.' },
    ];

    useEffect(() => {
        // Simulating fetching applications from a database or API
        const fetchedApplications = sampleApplications.filter(app => app.email === email);
        setApplications(fetchedApplications);
    }, [email]);

    useEffect(() => {
        // Show popup if any application status changes to Accepted or Rejected
        const statusChange = applications.find(app => app.status === 'Accepted' || app.status === 'Rejected');
        if (statusChange) {
            setPopup({
                show: true,
                message: statusChange.adminMessage,
                status: statusChange.status,
            });
        }
    }, [applications]);

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    // Inline styles
    const portalStyles = {
        backgroundColor: '#1e1e1e',
        color: 'white',
        padding: '20px',
        borderRadius: '8px',
    };

    const applicationBlockStyles = {
        display: 'flex',
        alignItems: 'center',
        margin: '10px 0',
        padding: '10px',
        backgroundColor: '#2c2c2c',
        borderRadius: '5px',
    };

    const statusLineStyles = (status) => ({
        width: '10px',
        height: '100%',
        marginRight: '10px',
        backgroundColor: status === 'Pending' ? 'yellow' : status === 'Accepted' ? 'green' : 'red',
    });

    const popupStyles = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const popupContentStyles = {
        backgroundColor: 'white',
        color: 'black',
        padding: '20px',
        borderRadius: '8px',
    };

    return (
        <div style={portalStyles}>
            <h1>Your Applications</h1>
            {applications.length > 0 ? (
                applications.map(app => (
                    <div key={app.id} style={applicationBlockStyles}>
                        <div style={statusLineStyles(app.status)}></div>
                        <div className="application-content">
                            <p><strong>Email:</strong> {app.email}</p>
                            <p><strong>Status:</strong> {app.status}</p>
                        </div>
                        {popup.show && app.status === popup.status && (
                            <div style={popupStyles} onClick={handlePopupClose}>
                                <div style={popupContentStyles}>
                                    <h2>{popup.status}</h2>
                                    <p>{popup.message}</p>
                                </div>
                            </div>
                        )}
                    </div>
                ))
            ) : (
                <p>No applications found for this email.</p>
            )}
        </div>
    );
};

export default Portal;
